import React from "react";

import F1WidgetWrap from "./widgetBoxes/formula1/F1WidgetWrap";
import { ColorVariables } from "../utils/general";

const Formula1Widgets = ({
  dataId,
  dataType,
  sport,
  data,
  baseUrl,
  loadCSS,
  dataClient = false,
  dataTitle,
  date,
}) => {
  const props = { dataId, dataType, sport, data, baseUrl, loadCSS, dataClient, dataTitle, date };

  // Inject the site's dynamic colour tokens (client only), same as other sports.
  React.useEffect(() => {
    if (!baseUrl) return;
    let styleTag;
    (async () => {
      try {
        const res = await fetch(`${baseUrl}/settings`, {
          headers: {
            Token: process.env.REACT_APP_SETTINGS_TOKEN,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (!res.ok) return;
        const settings = await res.json();
        styleTag = document.createElement("style");
        styleTag.textContent = ColorVariables(settings);
        document.head.appendChild(styleTag);
        document
          .querySelectorAll(".microservice-cont")
          ?.forEach((el) => el?.classList.add("hydrated"));
      } catch (err) {
        console.error("⚠️ Failed to load dynamic CSS settings:", err);
      }
    })();
    return () => {
      if (styleTag && document.head.contains(styleTag)) document.head.removeChild(styleTag);
    };
  }, [baseUrl]);

  if (dataType?.startsWith("f1-") || dataType?.startsWith("formula1-")) {
    return <F1WidgetWrap {...props} />;
  }

  return <h1>⚠️ Widget Not Found in Formula 1!</h1>;
};

export default Formula1Widgets;
